// Base
import { BaseApi } from '../base.api'

// Interface
import { IHomeWebpageApi, IHomeWebpageApiRequest, IHomeWebpageApiResponse, IHomeWebpageGetAttrs } from 'interfaces/webpage/home'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class HomeWebpageApi extends BaseApi<IHomeWebpageApi> implements IHomeWebpageApiRequest {
  readonly url = ApiConstant.HOME_URL
  private homeUrl = axios_renderUrl(this.url, ApiConstant.WEBPAGE)

  /**
   * @description Get home webpage
   *
   * @method POST
   * @url /home
   * @access public
   *
   * @return {Promise<IHomeWebpageApiResponse>} Promise<IHomeWebpageApiResponse>
   */
  async homeWebpage_getHome(payload: IHomeWebpageGetAttrs): Promise<IHomeWebpageApiResponse> {
    try {
      const response: IHomeWebpageApiResponse = await this.POST(this.homeUrl, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
